import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { styles } from "../SidePage.styles";
import { SidePageContext } from "../SidePageContext";
/**
 * Тело для сайдпейджа
 *
 * @visibleName SidePage.Body
 */

export var SidePageBody = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SidePageBody, _React$Component);

  function SidePageBody() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.context = _this.context;
    return _this;
  }

  var _proto = SidePageBody.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.context.updateLayout();
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("div", {
      className: styles.body()
    }, this.props.children));
  };

  return SidePageBody;
}(React.Component);
SidePageBody.__KONTUR_REACT_UI__ = 'SidePageBody';
SidePageBody.contextType = SidePageContext;